export class ToggleButtonEntity {
  id;
  label;
  icon;

  constructor(id, label, icon) {
    this.id = id;
    this.label = label;
    this.icon = icon;
  }
}
